import React, { useState } from 'react';
import { Box, Typography, TextField, Button, CircularProgress, Paper, Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const Designer = ({ open, onClose, order }) => {
  const [description, setDescription] = useState(order?.description || '');
  const [loading, setLoading] = useState(false);
  const [generatedImage, setGeneratedImage] = useState('');

  const handleGenerate = async () => {
    setLoading(true);
    setGeneratedImage('');
    // TODO: Wywołanie funkcji Firebase 'generateDesign'
    console.log('Generowanie projektu dla:', description);
    // Symulacja wywołania API
    setTimeout(() => {
      setGeneratedImage('https://via.placeholder.com/512.png?text=Wygenerowany+Projekt');
      setLoading(false);
    }, 2000);
  };

  if (!open) return null;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>
        Projektant AI dla zamówienia: {order?.id || 'Nowe'}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{ p: 2 }}>
          <Typography variant="h6" gutterBottom>Opis produktu do zaprojektowania</Typography>
          <TextField
            label="Opis produktu"
            multiline
            rows={4}
            fullWidth
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            variant="outlined"
            sx={{ mb: 2 }}
          />
          {loading && <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}><CircularProgress /></Box>}
          {generatedImage && (
            <Paper elevation={3} sx={{ p: 2, mt: 2 }}>
              <Typography variant="h6" gutterBottom>Wygenerowany projekt</Typography>
              <img src={generatedImage} alt="Wygenerowany projekt" style={{ maxWidth: '100%', height: 'auto' }} />
            </Paper>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Anuluj</Button>
        <Button onClick={handleGenerate} variant="contained" disabled={loading}>
          {loading ? 'Generowanie...' : 'Generuj projekt'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Designer;
